export const enum BOOLEAN_AS_STRING {
    TRUE = "true",
    FALSE = "false",
}
